import React from 'react';
import { Sparkle } from './Sparkle';
import { Breadcrumbs } from './Breadcrumbs';
interface PageHeaderProps {
  title: string;
  intro?: string;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  intro,
  children
}: PageHeaderProps) {
  return <div className="relative overflow-hidden border-b border-ink/10 bg-lavender" data-id="element-281" data-mp="3rcj6onw3p1he">
      <div className="relative mx-auto max-w-content px-5 pb-16 pt-8 sm:px-6 md:pb-20 md:pt-10" data-id="element-282" data-mp="3mgamux6ykk3w">
        <Sparkle className="absolute right-8 top-10 hidden h-7 w-7 md:block" data-id="element-283" data-mp="2yq7zgudzo2bm" />
        <Sparkle className="absolute right-24 top-24 hidden h-4 w-4 md:block" delay={1.5} data-id="element-284" data-mp="2ts6fm78qnyz3" />
        <Breadcrumbs data-id="element-285" data-mp="38gt4p0o6453i" />
        <h1 className="mt-6 max-w-3xl font-display text-[38px] leading-[1.08] tracking-tight text-ink md:text-[54px]" data-id="element-286" data-mp="38hb240mkgpd0">
          {title}
        </h1>
        {intro && <p className="mt-5 max-w-2xl text-[18px] text-ink/80" data-id="element-287" data-mp="2fyniyqr4rkek">{intro}</p>}
        {children}
      </div>
    </div>;
}